<input matInput ngModel [disabled]="disabled" [required]="required" [placeholder]="placeholder" [matAutocomplete]="auto"
    (blur)="_blur($event)" (focus)="_focus($event)" #autoTrigger="matAutocompleteTrigger" #input />
<mat-progress-bar *ngIf="pending" mode="indeterminate"></mat-progress-bar>
<mat-autocomplete autoActiveFirstOption [displayWith]="_getDisplayText" class="bp-address-search-panel"
     #auto="matAutocomplete">
    <mat-option *ngFor="let item of results | slice:0:maxItems" [value]="item">
        {{item.fullAddress}}
    </mat-option>
</mat-autocomplete>
